// project imports
import {
    processEntityInput as processEntityInputMain,
    processEntityOutput as processEntityOutputMain
} from 'store/serializers/fragments/main';
import {
    processEntityInput as processEntityInputSafeDeleter,
    processEntityOutput as processEntityOutputSafeDeleter
} from 'store/serializers/fragments/safe-deleter';
import {
    processEntityInput as processEntityInputLocker,
    processEntityOutput as processEntityOutputLocker
} from 'store/serializers/fragments/locker';
import { getIriFromObj } from 'utils/processors';

export const processEntityInput = (values) => ({
    ...values,
    ...processEntityInputMain(values),
    ...processEntityInputSafeDeleter(values),
    ...processEntityInputLocker(values)
});

export const processEntityOutput = (values) => ({
    ...values,
    ...processEntityOutputMain(values),
    ...processEntityOutputSafeDeleter(values),
    ...processEntityOutputLocker(values),
    employee: 'employee' in (values || {}) ? getIriFromObj(values.employee) : undefined,
    passwordExpirationTime: typeof values?.passwordExpirationTime === 'number' ? values.passwordExpirationTime : undefined,
    groups:
        'groups' in (values || {}) && Array.isArray(values.groups) ? values.groups.map((group) => getIriFromObj(group) || null) : undefined
});
